function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullscreenDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(372.4, 372.4)",
    style: {
      fill: "white"
    },
    d: "M93.1,139.6l46.5-46.5L93.1,46.5L139.6,0H0v139.6l46.5-46.5L93.1,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(372.4, -372.4)",
    style: {
      fill: "white"
    },
    d: "M93.1,372.4l-46.5,46.5L0,372.4V512h139.6l-46.5-46.5l46.5-46.5L93.1,372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M372.4,139.6H139.6v232.7h232.7V139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF0E43"
    },
    d: "M325.8,325.8H186.2V186.2h139.6V325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-372.4, 372.4)",
    style: {
      fill: "white"
    },
    d: "M372.4,0l46.5,46.5l-46.5,46.5l46.5,46.5l46.5-46.5l46.5,46.5V0H372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-372.4, -372.4)",
    style: {
      fill: "white"
    },
    d: "M418.9,372.4l-46.5,46.5l46.5,46.5L372.4,512H512V372.4l-46.5,46.5L418.9,372.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreenDisable);
export default __webpack_public_path__ + "static/media/icon-fullscreen-disable.f009a1c43b09f0aad0ed68bd33350e29.svg";
export { ForwardRef as ReactComponent };